// extracted by mini-css-extract-plugin
export default {"Chat":"Chat_Chat__VhcOQ","Input":"Chat_Input__6pyME","MessageList":"Chat_MessageList__4bZVh","Button":"Chat_Button__MSw4r"};